import React, {useCallback} from "react";
import { PLAY_DOMAIN } from "constant/config";
import { storeLaterViewVod } from "actions/post.action";
import LiveImage from "components/left/LiveImage";
import MoreButton from "components/MoreButton";
import { goLive, isWebbiewShareable, isWebview, numberCommaString, webviewShare } from "helpers";
import { Trans, withTranslation } from "react-i18next";

const LiveSection = ({ broad = {}}) => {
    /**
     * 라이브 공유하기
     */
    const handleShare = useCallback((close) => (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        const url = `${PLAY_DOMAIN}/${broad.user_id}/${broad.broad_no}`;
        webviewShare(url, broad.broad_title);
        close();
    }, [broad]);

    return (
        <section className="onAir_box">
            <div className="vod-box">
                <a href="" onClick={goLive(broad)}>
                    <span className="thum">
                        <LiveImage broad={broad} refresh={false} />
                        <div className="liveView">
                            {numberCommaString(broad.current_sum_viewer)}
                        </div>
                    </span>
                    <div className="vod-info">
                        <p className="title">{broad.broad_title}</p>
                    </div>
                </a>
                {/** <button type="button" className="btn-360deg small">360도</button> */}

                <MoreButton
                    top={35}
                    right={0}
                    trigger={
                        <button type="button" className="btn-detail">
                            <span>상세정보</span>
                        </button>
                    }
                >
                    {({ close }) => (
                        <>
                            <button type="button" onClick={() => storeLaterViewVod(broad.broad_no, "LIVE")}>
                                <span>
                                    <Trans>나중에 보기</Trans>
                                </span>
                            </button>
                            {isWebview && isWebbiewShareable() && (
                                <button type="button" onClick={handleShare(close)}>
                                    <span>
                                        <Trans>공유하기</Trans>
                                    </span>
                                </button>
                            )}
                        </>
                    )}
                    </MoreButton>
            </div>
        </section>
    );
    
}
export default LiveSection;
